import page from '../../../constants/pages/page';

export const UIHelpers = (customSortedKeyMap) => {
    return {
        sortedKeyMap: customSortedKeyMap,
        defaultSorted: [{ dataField: 'id', order: 'desc' }],
        initialFilter: {
            filters: null,
            sortOrder: 'desc',
            sortField: 'id',
            pageNumber: page.pageNumber,
            pageSize: localStorage.getItem('sizePerPage') || page.pageSize
        }
    };
};
